import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import Print from './Print';
import ClientProvider from './client';
export default createDemo(import.meta.url, Print, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/display/demos/print/Print.tsx",
    "fileName": "Print.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\n\nexport default function Print() {\n  return (\n    <div style={{ width: '100%' }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Box\n        sx={{\n          display: 'block',\n          displayPrint: 'none',\n          m: 1,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n        }}\n      >\n        Screen Only (Hide on print only)\n      </Box>\n      <Box\n        sx={{\n          display: 'none',\n          displayPrint: 'block',\n          m: 1,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n        }}\n      >\n        Print Only (Hide on screen only)\n      </Box>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 30,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\n\nexport default function Print() {\n  return (\n    <div style={{ width: '100%' }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <Box\n        sx={{\n          display: 'block',\n          displayPrint: 'none',\n          m: 1,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n        }}\n      >\n        Screen Only (Hide on print only)\n      </Box>\n      <Box\n        sx={{\n          display: 'none',\n          displayPrint: 'block',\n          m: 1,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n        }}\n      >\n        Print Only (Hide on screen only)\n      </Box>\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "totalLines": 30,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
